exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h4.capitalize {\n    text-transform: capitalize;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/static-comp/static-comp.component.css
// module id = ../../../../../src/app/layout/static-comp/static-comp.component.css
// module chunks = main